import { render, staticRenderFns } from "./MprDashboard.vue?vue&type=template&id=04514c84&scoped=true"
import script from "./MprDashboard.vue?vue&type=script&lang=js"
export * from "./MprDashboard.vue?vue&type=script&lang=js"
import style0 from "./MprDashboard.vue?vue&type=style&index=0&id=04514c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04514c84",
  null
  
)

export default component.exports